export type WorkerAPI<T, R> = {
  send: (message: T) => void
  on: (handler: (data: R) => void) => void
}
